import React from "react";
import { SCP_LOGO, NC_LOGO } from "../lib/api";
import { Mail, MessageCircle } from "lucide-react";

export default function Footer({ camp }) {
  return (
    <footer className="bg-[#03281B] text-white/70 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-wrap items-center gap-5 pb-8 mb-8 border-b border-white/10">
          <img src={SCP_LOGO} alt="Sporting Clube de Portugal crest" className="h-14 w-auto" />
          <div className="h-10 w-px bg-white/20" />
          <img src={NC_LOGO} alt="Northcrest Athletics LLC logo" className="h-12 w-auto rounded" />
          <div className="text-xs text-white/50 leading-relaxed">
            In collaboration with<br /><span className="text-white/80 font-semibold">Sporting Clube de Portugal</span> &amp; <span className="text-white/80 font-semibold">Northcrest Athletics LLC</span>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="font-display font-extrabold text-white text-xl">SPORTING CP CAMP SAN DIEGO 2027</div>
          <p className="text-sm mt-2">Organized by Northcrest Athletics LLC</p>
          <p className="text-sm mt-1">Point Loma Nazarene University, San Diego, California, USA</p>
          <p className="text-sm">June 9-13, 2027</p>
          <div className="mt-4 space-y-1.5 text-sm">
            <a href="mailto:sandiego@northcrestathletics.com" className="flex items-center gap-2 hover:text-white"><Mail size={15} /> sandiego@northcrestathletics.com</a>
            <a href="https://wa.me/16193010987" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white"><MessageCircle size={15} /> WhatsApp +1 619-301-0987</a>
          </div>
        </div>
        <div>
          <div className="text-[#F3C242] font-bold uppercase text-xs tracking-widest mb-3">Camp</div>
          <ul className="space-y-1.5 text-sm">
            <li><a href="/#overview" className="hover:text-white">Overview</a></li>
            <li><a href="/#pricing" className="hover:text-white">Pricing</a></li>
            <li><a href="/#services" className="hover:text-white">Optional Services</a></li>
            <li><a href="/register" className="hover:text-white">Register</a></li>
          </ul>
        </div>
        <div>
          <div className="text-[#F3C242] font-bold uppercase text-xs tracking-widest mb-3">Legal</div>
          <ul className="space-y-1.5 text-sm">
            <li><a href="/terms" className="hover:text-white">Terms & Conditions</a></li>
            <li><a href="/privacy" className="hover:text-white">Privacy Policy</a></li>
          </ul>
          <p className="text-[11px] mt-4 text-white/40">All prices in USD. Payments processed securely.</p>
        </div>
      </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">
        &copy; 2027 Northcrest Athletics LLC. All rights reserved.
      </div>
    </footer>
  );
}
